/* ============================================
   PROMO 2 PARES
   Ruta: assets/promo-2-pares.js
   ============================================ */

(function () {
  if (window.__rocaPromo2ParesInit) return;
  window.__rocaPromo2ParesInit = true;

  function getCatalogUrl() {
    var el = document.querySelector('[data-catalog-url]');
    return (el && el.getAttribute('data-catalog-url')) || '/collections/all';
  }

  function renderBanner(el, count) {
    var textEl = el.querySelector('[data-promo-2pares-text]');
    if (!textEl) return;
    var remainder = count % 2;

    el.style.display = 'flex';

    if (count === 0) {
      el.classList.remove('is-complete');
      textEl.innerHTML =
        'Agrega <strong>2 pares</strong> de cualquier modelo al carrito y paga <strong>$179.900</strong> por los dos (antes $220.000)';
    } else if (remainder === 1) {
      el.classList.remove('is-complete');
      textEl.innerHTML =
        'Añade 1 par más de cualquier modelo al carrito y paga <strong>$179.900</strong> por los dos en vez de $220.000 — ' +
        '<a href="' + getCatalogUrl() + '" class="promo-2pares__link">Ver más modelos</a>';
    } else {
      el.classList.add('is-complete');
      textEl.innerHTML = '✅ ¡Promo aplicada en tu carrito! Pagas <strong>$179.900</strong> por tus 2 pares';
    }
  }

  function updateAllBanners(cart) {
    document.querySelectorAll('[data-promo-2pares]').forEach(function (el) {
      renderBanner(el, cart.item_count);
    });
  }

  var fetchTimer = null;
  function fetchCart() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(updateAllBanners)
        .catch(function () {});
    }, 250);
  }

  document.addEventListener('cart:updated', fetchCart);
  document.addEventListener('cart:refresh', fetchCart);
  document.addEventListener('cart:build', fetchCart);

  var watchedContainers = new WeakSet();
  var containerSelectors = [
    '.cart-drawer__items',
    'cart-items-component',
    '#main-cart-items',
    '.cart-items'
  ];

  function attachContainerObservers() {
    containerSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (watchedContainers.has(node)) return;
        watchedContainers.add(node);
        var mo = new MutationObserver(fetchCart);
        mo.observe(node, { childList: true, subtree: true, characterData: true });
      });
    });
  }

  attachContainerObservers();
  var rescan = new MutationObserver(attachContainerObservers);
  rescan.observe(document.body, { childList: true, subtree: true });

  /* ===== POPUP tras "Agregar al carrito" ===== */
  function showPromoModal(count) {
    var existing = document.querySelector('.promo-2pares-modal-overlay');
    if (existing) existing.remove();

    var remainder = count % 2;
    var isComplete = count > 0 && remainder === 0;

    var overlay = document.createElement('div');
    overlay.className = 'promo-2pares-modal-overlay';

    var icon = isComplete ? '✅' : '🔥';
    var title = isComplete ? '¡Promo aplicada!' : 'Te falta 1 par';
    var text = isComplete
      ? 'Pagas <strong>$179.900</strong> por tus 2 pares en vez de $220.000.'
      : 'Tienes 1 par en tu carrito. Agrega 1 más de cualquier modelo y paga <strong>$179.900</strong> por los dos.';

    var actionsHtml = isComplete
      ? '<a href="/cart" class="promo-2pares-modal__btn promo-2pares-modal__btn--primary">Ir al carrito</a>' +
        '<button type="button" class="promo-2pares-modal__btn promo-2pares-modal__btn--secondary" data-promo-modal-close>Seguir comprando</button>'
      : '<a href="' + getCatalogUrl() + '" class="promo-2pares-modal__btn promo-2pares-modal__btn--primary">Ver más modelos</a>' +
        '<button type="button" class="promo-2pares-modal__btn promo-2pares-modal__btn--secondary" data-promo-modal-close>Cerrar</button>';

    overlay.innerHTML =
      '<div class="promo-2pares-modal" role="dialog" aria-modal="true">' +
        '<button type="button" class="promo-2pares-modal__close" data-promo-modal-close aria-label="Cerrar">×</button>' +
        '<div class="promo-2pares-modal__icon">' + icon + '</div>' +
        '<div class="promo-2pares-modal__title">' + title + '</div>' +
        '<div class="promo-2pares-modal__text">' + text + '</div>' +
        '<div class="promo-2pares-modal__actions">' + actionsHtml + '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || (e.target.closest && e.target.closest('[data-promo-modal-close]'))) {
        overlay.remove();
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      setTimeout(function () {
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            updateAllBanners(cart);
            showPromoModal(cart.item_count);
          })
          .catch(function () {});
      }, 800);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCart);
  } else {
    fetchCart();
  }
})();